import React from 'react';
import { Clock, CheckCircle, AlertCircle, User, Building2, Briefcase } from 'lucide-react'; //  ADICIONE Briefcase
import '../Chat.scss';

const ChatItem = ({ conversation, isSelected, onClick }) => {
  const getStatusIcon = () => {
    if (conversation.status === 'closed') {
      return <CheckCircle size={14} className="chat-item__status-icon--closed" />;
    }
    if (conversation.status === 'pending') {
      return <Clock size={14} className="chat-item__status-icon--pending" />;
    }
    return null;
  };

  const formatTime = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const now = new Date();
    const diff = now - d;
    
    if (diff < 60000) return 'Agora';
    if (diff < 3600000) return `${Math.floor(diff / 60000)}min`;
    if (diff < 86400000) return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  };

  return (
    <div 
      className={`chat-item ${isSelected ? 'chat-item--selected' : ''}`}
      onClick={onClick}
    >
      <div className="chat-item__avatar">
        {conversation.avatar ? (
          <img src={conversation.avatar} alt={conversation.title} />
        ) : (
          <span>{conversation.title?.charAt(0).toUpperCase()}</span>
        )}
        {conversation.unreadCount > 0 && (
          <span className="chat-item__unread">{conversation.unreadCount}</span>
        )}
      </div>

      <div className="chat-item__content">
        <div className="chat-item__header">
          <span className="chat-item__title">{conversation.title}</span>
          <span className="chat-item__time">{formatTime(conversation.lastMessageAt)}</span>
        </div>

        <div className="chat-item__preview">
          {conversation.lastMessagePreview ? (
            <>
              {conversation.status === 'closed' && (
                <span className="chat-item__closed-badge">
                  <CheckCircle size={12} />
                  Fechado
                </span>
              )}
              <span className="chat-item__preview-text">
                {conversation.lastMessagePreview}
              </span>
            </>
          ) : (
            <span className="chat-item__preview-empty">
              Nenhuma mensagem ainda
            </span>
          )}
        </div>

        {conversation.jobTitle && (
          <div className="chat-item__meta">
            <Briefcase size={12} /> {/*  AGORA O Briefcase ESTÁ DEFINIDO */}
            <span>{conversation.jobTitle}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatItem;